import React, { useState, useEffect } from 'react'
import './AddNewTemplates.scss'
import asideModalStore from 'Stores/asideModalStore'
import FormFieldset from 'components/UI/AsideModal/Form/FormFieldset'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import FormField from 'components/UI/AsideModal/Form/FormField'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import { observer } from 'mobx-react'
import CheckboxToggle from 'components/ContentBox/Global/CheckboxToggle/CheckboxToggle'
import Flex from 'components/UI/Flex/Flex'
import FileSelector from 'components/UI/FileSelector/FileSelector'

const fileTypes = [
  { id: 1, name: 'image', label: 'Image' },
  { id: 2, name: 'audio', label: 'Audio' },
  { id: 3, name: 'video', label: 'Video' },
  { id: 4, name: 'document', label: 'Document' },
]

const AddNewTemplates = () => {
  const { modalValues, changeValue, check } = asideModalStore
  const [currentFileFormat, setCurrentFileFormat] = useState(null)
  const [selectedFileType, setSelectedFileType] = useState(null)

  useEffect(() => {
    if (typeof modalValues?.file_type === 'string') {
      const foundOption = fileTypes.find(
        (type) => type.name === modalValues.file_type,
      )
      setSelectedFileType(foundOption || null)
      if (foundOption) {
        setCurrentFileFormat(foundOption.name)
      }
    } else {
      setSelectedFileType(modalValues?.file_type || null)
      setCurrentFileFormat(modalValues?.file_type?.name || null)
    }
  }, [modalValues?.file_type])

  const renderFileSelector = (format) => {
    const normalizeFileValue = () => {
      const file = modalValues?.file
      if (!file) return ''
      if (typeof file === 'object' && Object.keys(file).length === 0) return ''
      if (typeof file === 'string') return file
      return ''
    }

    const fileSelectorProps = {
      value: normalizeFileValue(),
      onChange: (val) => changeValue(val, 'file'),
      error: check('file'),
      crm: true,
    }

    switch (format) {
      case 'image':
        return (
          <FileSelector
            types={['jpeg', 'jpg', 'png', 'tif']}
            {...fileSelectorProps}
          />
        )
      case 'audio':
        return (
          <FileSelector types={['mp3']} type='audio' {...fileSelectorProps} />
        )
      case 'video':
        return (
          <FileSelector types={['mp4']} type='video' {...fileSelectorProps} />
        )
      case 'document':
        return (
          <FileSelector
            types={[
              'pdf',
              'xls',
              'xlsx',
              'doc',
              'docx',
              'pptx',
              'ppt',
              'txt',
              'zip',
              'rar',
              'jpeg',
              'jpg',
              'png',
              'tif',
            ]}
            type='file'
            {...fileSelectorProps}
          />
        )
      default:
        return null
    }
  }

  const handleFileTypeChange = (val) => {
    changeValue(val, 'file_type')
    setCurrentFileFormat(val.name)
    changeValue(null, 'file')
  }

  return (
    <FormFieldset>
      <FormField>
        <FormLabel isRequired>Название шаблона:</FormLabel>
        <FormInput isError={check('title')}>
          <input
            placeholder={'Название шаблона'}
            type='title'
            value={modalValues?.title || ''}
            onChange={(e) => changeValue(e.target.value, 'title')}
          />
        </FormInput>
      </FormField>

      <FormField>
        <FormLabel isRequired>Текст шаблона:</FormLabel>
        <FormInput isError={check('text')}>
          <textarea
            placeholder={'Текст шаблона'}
            type='text'
            value={modalValues?.text || ''}
            onChange={(e) => changeValue(e.target.value, 'text')}
          />
        </FormInput>
      </FormField>

      <FormField>
        <FormLabel>Выбрать канал:</FormLabel>
        <SelectCustom
          placeholder={'Выбрать канал'}
          valueID={modalValues?.channel_id || [] || null}
          onChange={(temp) => changeValue(temp.channel_id, 'channel_id')}
          apiLinkCRM={'integration/channels'}
          error={check('channel_id')}
          optionValueKey='channel_id'
          getOptionValue={(option) => option.channel_id}
        />
      </FormField>

      <FormField>
        <FormLabel>Тип файла:</FormLabel>
        <SelectCustom
          options={fileTypes}
          onChange={handleFileTypeChange}
          value={selectedFileType}
          placeholder={'Выбрать тип файла'}
          error={check('file_type')}
        />
      </FormField>

      {currentFileFormat && (
        <FormField>
          <FormLabel>
            {currentFileFormat === 'audio'
              ? 'Аудио файл:'
              : currentFileFormat === 'video'
                ? 'Видео файл:'
                : currentFileFormat === 'image'
                  ? 'Изображение:'
                  : 'Документ:'}
          </FormLabel>
          {renderFileSelector(currentFileFormat)}
        </FormField>
      )}

      <FormField>
        <Flex>
          <CheckboxToggle
            right={'Сделать активным'}
            checked={modalValues?.is_active}
            onChange={() => changeValue(!modalValues?.is_active, 'is_active')}
          />
        </Flex>
      </FormField>
    </FormFieldset>
  )
}

export default observer(AddNewTemplates)
